import { isNil } from 'lodash';
import { globalFormat } from '../../../../utils/formatting';
import Loader from '../../../../components/Loaders/Loader';
import React from 'react';
import PlanProgressBar from '../PlanProgressBar';
import { ChartMode } from '../../../../components/Chart/types';
import * as PlanDetailsUI from '../PlanDetailsUI';
import { useCustomerPlanMTUReport } from '../hooks/useCustomerPlanMTUReport';
import { useCseAdminFeature } from '../../../../utils/hooks';
import NoReport from '../NoReport';
import { PlanActionsAdmin } from '../PlanActions';
import ReportSearchModal from '../../../../components/ReportSearchModal';
import { calculatePlanMonths } from '../PlanUtils';
import useCustomerPlan from '../../../../utils/hooks/useCustomerPlan';

const PlanMonthly = () => {
  const { dateFormat, timeFormat } = globalFormat.getGlobalFormat();
  const isAdmin = useCseAdminFeature();
  const { plan, loading, report, analysisId, total, openSearch, isModalOpen } =
    useCustomerPlanMTUReport();
  const { maxSchemas, maxSeats } = useCustomerPlan();

  if (loading) {
    return (
      <PlanDetailsUI.Details>
        <Loader loadingText="Loading..." />
      </PlanDetailsUI.Details>
    );
  }

  if (!plan || !report) {
    /**
     * if the user is admin and there is plan set, then allow the admin to set MTU report
     * but only if the plan is not seat or schema based
     */
    if (isAdmin && plan && !maxSchemas && !maxSeats) {
      return (
        <>
          <NoReport onEdit={openSearch} />
          {isModalOpen && <ReportSearchModal type="add-report" />}
        </>
      );
    }
    return null;
  }

  const { executedAt, start, end } = report;

  const months = calculatePlanMonths(
    plan.contractPeriod.start,
    plan.contractPeriod.end,
  );

  return (
    <PlanDetailsUI.Details>
      <PlanDetailsUI.Header>
        <PlanDetailsUI.MonthlyHeader>
          <PlanDetailsUI.MonthlyTitle>
            Monthly tracked users (MTU)
          </PlanDetailsUI.MonthlyTitle>
          <PlanDetailsUI.MonthlyLastExecution>
            Last Updated:{' '}
            {!isNil(executedAt)
              ? globalFormat.formatDate(executedAt, {
                  dateFormat,
                  timeFormat,
                })
              : 'N/A'}
          </PlanDetailsUI.MonthlyLastExecution>
        </PlanDetailsUI.MonthlyHeader>
      </PlanDetailsUI.Header>
      <PlanDetailsUI.Bars>
        <PlanDetailsUI.MTUProgressBar>
          <PlanProgressBar
            title="Overall MTU usage"
            fromDate={start}
            toDate={end}
            currentValue={total}
            maxValue={(plan?.mtuLimit ?? 1) * months}
          />
        </PlanDetailsUI.MTUProgressBar>
      </PlanDetailsUI.Bars>
      <PlanDetailsUI.MTUChartContainer>
        <PlanDetailsUI.MTUChart
          analysisId={analysisId}
          mode={ChartMode.View}
          optionsEnabled={true}
          isEmbedded={false}
        />

        {isAdmin && (
          <PlanActionsAdmin onClick={openSearch} title="Change Report" />
        )}
      </PlanDetailsUI.MTUChartContainer>
      {isModalOpen && <ReportSearchModal type="add-report" />}
    </PlanDetailsUI.Details>
  );
};

export default PlanMonthly;
